import mitt from 'mitt';

export const BUS_EVENTS = [
  'TOOL_STEP_LOADED',
  'TOOL_STEP_CHANGED',
  'TOOL_FEEDBACK_PRESENTED',
  'ROUTE_CHANGED',
  'APPOINTMENT_CREATED',
  'APPOINTMENT_APP_SEGMENTATION_CHANGED',
  'INTEREST_COMPARE_CALCULATION_TRIGGERED',
  'INTEREST_COMPARE_RESULTS_SORTED',
  'INTEREST_COMPARE_ITEM_EXPANDED',
  'INTEREST_COMPARE_LOADED',
  'VH_APPOINTMENT_LOADED',
  'VH_APPOINTMENT_SUCCESS',
];

const $bus = {};

let hasInit = false;

export const createEventHandler = (event, emitter) => {
  return {
    emit(payload) {
      emitter.emit(event, payload);
      this.history.push({ payload, timestamp: new Date() });
    },
    listen(callback) {
      emitter.off(event, callback);
      emitter.on(event, callback);
    },
    history: [],
    get listeners() {
      return emitter.all.get(event);
    },
  };
};

export const initExternalEventBus = () => {
  if (hasInit)
    return $bus;

  const emitter = mitt();
  BUS_EVENTS.forEach(event => $bus[event] = createEventHandler(event, emitter));

  hasInit = true;

  if (process.env.NODE_ENV === 'development')
    global.$bus = $bus;

  return $bus;
};
